import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/layouts/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import GlobalStyle from "@/style/GlobalStyle";
import { I18nextProvider } from "react-i18next";
import i18n from "./lang/i18n";
import { SafeArea } from "./utils/SafeArea";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* Global CSS */}
      <GlobalStyle />
      <I18nextProvider i18n={i18n}>
        {/* <SafeArea top /> */}
        <App />
        <SafeArea bottom />
      </I18nextProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
